module.exports = __webpack_public_path__ + "static/media/home-ana-awards-future.dbc96920.webp";